import { Row } from "react-bootstrap";
import Datetime from "react-datetime";
import NationalityPersonalInformationPreview from "../PersonalInformation/NationalityPersonalInformationPreview";
import { useInterviewContext } from "../../InterviewContext";
import { useTranslation } from "react-i18next";
import "moment/locale/pt";
import "moment/locale/fr";
import "moment/locale/en-gb";
import moment from "moment";
import CurrentLocation from "../../PersonalInformation/CurrentLocation";

const PersonalInformationPreview = ({ interview }) => {
  const { t } = useTranslation();
  const { i18n } = useTranslation();

  function getDateValueValid(date) {
    if (date) {
      return moment(new Date(interview.personalInformation.birthDate)).format(
        "DD-MM-YYYY"
      );
    }
  }

  function getCandidateAge(date) {
    const today = new Date();
    const birthDate = new Date(date);
    if (date) {
      return Math.floor(
        Math.ceil(
          Math.abs(birthDate.getTime() - today.getTime()) / (1000 * 3600 * 24)
        ) / 365.25
      );
    }
  }

  return (
    <div>
      <form className="form-group">
        <Row>
          <h1>{t("Personal Details")}</h1>

          <div className="col-md-6">
            <div className="form-group">
              <div className="label-wrapper">
                <label htmlFor="personalDetailLabelFullName">
                  {t("Full Name*")}
                </label>
              </div>
              <input
                id="fullName"
                name="fullName"
                type="text"
                value={interview.personalInformation.fullName}
                disabled
              />
            </div>
          </div>

          <div className="col-md-2">
            <div className="form-group">
              <div className="label-wrapper">
                <label htmlFor="personalDetailLabelDateOfBirth">
                  {t("Date of birth*")}
                </label>
              </div>
              <div>
                <Datetime
                  inputProps={{ id: "birthDate", disabled: true }}
                  className="birthDate-position"
                  name="birthDate"
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  value={getDateValueValid(
                    interview.personalInformation.birthDate
                  )}
                  utc={true}
                  closeOnSelect={true}
                  locale={
                    i18n.language === "PT"
                      ? "PT"
                      : i18n.language === "FR"
                      ? "FR"
                      : "EN"
                  }
                />
                {interview.personalInformation.birthDate ? (
                  <label className="age-position">
                    {" ( " +
                      getCandidateAge(interview.personalInformation.birthDate) +
                      " " +
                      t("Years") +
                      " )"}
                  </label>
                ) : (
                  " "
                )}
              </div>
            </div>
          </div>
        </Row>{" "}
        <Row style={{ alignItems: "center" }}>
          <div className="col-md-4">
            <div className="form-group">
              <div className="label-wrapper">
                <label htmlFor="personalDetailLabelMaritalStatus">
                  {t("Marital Status")}
                </label>
              </div>
              <select
                id="maritalStatusId"
                name="maritalStatusId"
                className="form-select"
                disabled
              >
                <option>{interview.personalInformation.maritalStatus}</option>
              </select>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <div className="label-wrapper">
                <label htmlFor="personalDetailLabelNumberOfDependants">
                  {t("Nº of dependants")}
                </label>
              </div>
              <select
                id="numberOfDependents"
                name="numberOfDependents"
                className="form-select"
                disabled
              >
                <option>
                  {interview.personalInformation.numberOfDependentsLabel}
                </option>
              </select>
            </div>
          </div>
        </Row>
        <Row>
          <div className="col-md-3">
            <div className="form-group">
              <div className="label-wrapper">
                <label htmlFor="personalDetailLabelZone">{t("Zone")}</label>
              </div>
              <select
                id="zoneId"
                name="zoneId"
                className="form-select"
                disabled
              >
                <option>{interview.personalInformation.addressZone}</option>
              </select>
            </div>
          </div>
          <div className="col-md-5">
            <CurrentLocation
              currentLocation={interview.personalInformation.currentLocation}
              viewMode={true}
            ></CurrentLocation>
          </div>
        </Row>
        <div>
          {interview.personalInformation.nationalityNames.length > 0 ? (
            interview.personalInformation.nationalityNames.map(
              (nationality, index) => (
                <NationalityPersonalInformationPreview
                  nationality={nationality}
                  isForeingWithOutDoc={
                    interview.personalInformation.isForeingWithOutDoc
                  }
                  index={index}
                />
              )
            )
          ) : (
            <div>
              <NationalityPersonalInformationPreview index={0} />
            </div>
          )}
        </div>
        <Row className="section-divider">
          <h1>{t("Contacts")}</h1>
          <Row>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label>{t("Email address*")}</label>
                </div>
                <input
                  id="emailAddress"
                  name="emailAddress"
                  type="text"
                  value={interview.personalInformation.emailAddress}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelPhoneNumber">
                    {t("Mobile number*")}
                  </label>
                </div>
                <input
                  className="input-field"
                  id="mobilePhoneNumber"
                  name="mobilePhoneNumber"
                  type="tel"
                  disabled
                />
                <a
                  className="phone-position"
                  href={`tel:${interview.personalInformation.mobilePhoneNumber}`}
                >
                  {interview.personalInformation.mobilePhoneNumber}
                </a>
              </div>
            </div>
          </Row>
        </Row>
        <Row className="section-divider">
          <h1>{t("Links")}</h1>
          <Row>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelLinkedin">
                    {t("LinkedIn (URL)")}
                  </label>
                </div>
                <input
                  className="input-field"
                  type="text"
                  placeholder="https://www.linkedin.com/in"
                  id="linkedIn"
                  name="linkedIn"
                  value={interview.personalInformation.linkedIn}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <div className="label-wrapper">
                  <label htmlFor="personalDetailLabelGitHub">
                    {t("GitHub (URL)")}
                  </label>
                </div>
                <input
                  className="input-field"
                  type="text"
                  placeholder="https://github.com"
                  id="gitHub"
                  name="gitHub"
                  value={interview.personalInformation.gitHub}
                  disabled
                />
              </div>
            </div>
          </Row>
        </Row>
      </form>
    </div>
  );
};

export default PersonalInformationPreview;
